export const ENUM__http_route = {
  STRIPE_CHECKOUT_RESULT: '/api/stripe/checkout_result',

  GOOGLE_AUTH_START: '/api/auth/google/start',
  GOOGLE_AUTH_CALLBACK: '/api/auth/google/callback',

  MICROSOFT_AUTH_START: '/api/auth/microsoft/start',
  MICROSOFT_AUTH_CALLBACK: '/api/auth/microsoft/callback',

  GITHUB_AUTH_START: '/api/auth/github/start',
  GITHUB_AUTH_CALLBACK: '/api/auth/github/callback',

  DISCORD_AUTH_START: '/api/auth/discord/start',
  DISCORD_AUTH_CALLBACK: '/api/auth/discord/callback',

  FACEBOOK_AUTH_START: '/api/auth/facebook/start',
  FACEBOOK_AUTH_CALLBACK: '/api/auth/facebook/callback',
};
